export default __webpack_public_path__ + "static/media/magic-story-edited.8b23d2a3.mp4";